import { Divider, Fab, Grid, makeStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import AppErrorBoundary from './ErrorBoundaries/AppErrorBoundary';
import Text from './Text';

const useStyles = makeStyles((theme) => ({
    root: {
        // display: 'none !important',
        [theme.breakpoints.down("sm")]: {
            '& .MuiFab-root': {
                '& .MuiFab-label': {
                    '& svg': {
                        width: '1rem',
                        height: 'auto'
                    },
                    '& span': {
                        display: 'none'
                    }
                }
            },
            '& .MuiFab-label': {
                '& svg': {
                    width: '1rem',
                    height: 'auto'
                },
                '& span': {
                    display: 'none'
                }
            }
        }
    },
    screenTitle: {
        color: theme.palette.primary.main,
        marginBottom: '1rem',
        fontSize: 24,
        [theme.breakpoints.down("sm")]: {
            fontSize: '1.35rem'
        }
    },
    backButton: {
        marginRight: '0.5rem',
        boxShadow: 'none',
        padding: 0,
        height: '1.75rem',
        minWidth: '1.75rem',

        '& svg': {
            width: '0.95rem'
        }
    }
}))

const ScreenWrapper = ({
    pageTitle = '',
    ActionComponent,
    children,
    hasForm,
    onSubmit,
}) => {
    const classes = useStyles();
    const methods = useForm();
    const history = useHistory();

    React.useEffect(() => {
        document.title = pageTitle && pageTitle.length > 0 ? `${pageTitle} - Hoichoi Offers Admin` : 'Hoichoi Admin'
    }, [pageTitle])
    return (
        <>
            <Grid container>
                <Grid item xs={8} style={{ display: 'flex' }}>
                    <Fab className={classes.backButton} onClick={history.goBack} variant="extended" color="primary" aria-label="back">
                        <ArrowBack />
                    </Fab>
                    <Text variant='h1' className={classes.screenTitle}>{pageTitle}</Text>
                </Grid>
                <Grid item xs={4} style={{ textAlign: 'right' }}>
                    {!!ActionComponent && <ActionComponent className={classes.root} />}

                </Grid>
            </Grid>
            <Divider style={{ marginBottom: '1rem' }} />

            {hasForm ?
                (
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                            <AppErrorBoundary>
                                {children}
                            </AppErrorBoundary>
                        </form>
                    </FormProvider>
                ) : <AppErrorBoundary>{children}</AppErrorBoundary>
            }
        </>
    )
}

export default ScreenWrapper
